<template>
  <section>
    <Title class="has-text-centered" />
    <Social class="has-text-centered" />
    <div class="columns is-variable is-12 margin-top">
      <MarkdownBlogs />
    </div>
  </section>
</template>

<script>
import Social from "@/components/Layout/Home/Social";
import Title from "@/components/Layout/Home/Title";
import Technologies from "../components/Layout/Home/Technologies";
import LatestBlog from "../components/Layout/Home/LatestBlog";
import LatestTweet from "../components/Layout/Home/LatestTweet";
import MarkdownBlogs from "@/components/Layout/MarkdownBlog/MarkdownBlogs.vue";

export default {
  components: {
    MarkdownBlogs,
    Technologies,
    Title,
    Social,
    LatestBlog,
    LatestTweet,
  },
  name: "home",
  mounted() {},
};
</script>
<style>
.margin-top {
  margin-top: 50px;
}
</style>
